module.exports = __webpack_public_path__ + "static/media/effect_06.ecccea7d.png";